// extracted by mini-css-extract-plugin
export default {"form-checkboxes":"G0lhuSsLm6QD4LZbann2","form-checkbox":"X4TUMqx5PPJ9C71U6zHS","checkbox-label-helper":"ESsWDP_7E6KB5RciEaTD"};